/* Lotta is currently using named brakpoint "md" (960) from Material-UI
  xs, extra-small: 0px or larger
  sm, small:       600px or larger
  md, medium:      960px or larger
  lg, large:       1280px or larger
  xl, extra-large: 1920px or larger */

export const MOBILE_BREAKPOINT = 960
